import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { CircularProgress } from "@mui/material";
import LabelCS from "../../components/LabelCS";
import TextFieldCS from "../../components/TextFieldCS";
import BotonCS from "../../components/BotonCS";
import ModalCS from "../../components/ModalCS";
import DropDownListCS from "../../components/DropDownListCS";
import Alert from "../../components/Alert";
import { INTELISIS, REGISTRAR } from "../../tools/ApiRoutes";
import enviarPeticion from "../../tools/EnviarPeticion";
import validFiles from "../../tools/validFiles";
import formatDate from "../../tools/FormatDate";
import ObtenerToken from "../../tools/ObtenerToken";
import { sqlCampo, sqlComentario } from "../../tools/SqlInjection";
import { Delete } from "@mui/icons-material";
import {Tooltip} from '@mui/material';

const FormularioAlta = () => {
    const [ formulario, setFormulario ] = useState({});
    const [ loading, setLoading ] = useState(false);
    const [ rut, setRut ] = useState(null);
    const [ docs, setDocs ] = useState([]);
    const [ disabled, setDisabled ] = useState({});
    const [ showModal, setShowModal ] = useState(false);
    const [ alert , setAlert ] = useState({ msg: '', severity: 'success', open: false }); //MODAL NOTIFICACIONES
    const [ check, setCheck ] = useState(false);
    const [ files, setFiles ] = useState({});

    //JUNTA LAS OTRAS ACTIVIDADES EN UNA SOLA CADENA
    const otrasActividades = () => {
        let res = "";

        if (rut !== null){
            if (formulario.ActividadEconomica3 !== "") res = formulario.ActividadEconomica3;
            if (formulario.ActividadEconomica4 !== "") res += ", "+formulario.ActividadEconomica4;
        }
        
        return res;
    }
    const otrasAct = otrasActividades();

    const archivosElegidos = (docs) => {
        let files = {
            ccc: null,
            irl: null,
            cr1: null,
            cr2: null
        };

        docs.forEach(item => {
            if (item.name.replace(".pdf","") === "CamaraComercio") files.ccc = true;
            if (item.name.replace(".pdf","") === "RepresentanteLegal") files.irl = true;
            if (item.name.replace(".pdf","") === "Referencia1") files.cr1 = true;
            if (item.name.replace(".pdf","") === "Referencia2") files.cr2 = true;
        });
        
        return files;
    }


    //CIERRA MENSAJE DE VALIDACIÓN
    const closeAlert = () => setAlert({ msg: '', severity: 'success', open: false });

    const checkHabeasData = () => {
        if (check === true){
            setCheck(false)
        }else{
            setCheck(true);
        }
    }

    const cerrarModal = () => {
        setRut(null);
        setFormulario({});
        setCheck(false);
        setDocs([]);
        setFiles({});
        setShowModal(false);
    }

    const evaluarProp = (valor) =>{
        if (valor === undefined || valor === null || valor === "")
            return false;
        else    
            return true;
    }

    //DEFINE LOS CAMPOS FALTANTES Y LOS DEJA HABILITADOS
    const camposFaltgantes = (rut) => {
        const objNuevo = {};
        for (let prop in rut){
            objNuevo[prop] = evaluarProp(rut[prop]);
        }

        setDisabled(objNuevo);
    }

    const validarNIT = async (NIT, token) => {
        const config = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        };
    
        const res = await enviarPeticion(config, `${INTELISIS.BuscarCliente}${NIT}`);

        //SI REGRESA TRUE ES PORQUE YA EXISTE
        if (res.success === true){
            return false;
        }
        else{
            return true;
        }
    }

    const validarSolicitudPendiente= async (NIT) => {
        const token = '0200000066AEABE55060E60316BE65817C41A37B8BC1C49EA5407A25B83D6C604778FFD6CAFF7A2F04CD0277BC0BA31F0B50B85F';

        const config = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        };
    
        const res = await enviarPeticion(config, `${REGISTRAR.SolicitudPendiente}?param=${NIT}`);

        if (res.Message === "No hay solicitudes"){
            return false;
        }
        else{
            return true;
        }
    }

    //SUBIR Y LEER RUT
    const subirRUT = async (archivos) => {
        const data = new FormData();

        //AGREGAMOS CADA UNO DE LOS ARCHIVOS
        archivos.forEach((item) => {
            data.append('archivos', item);
        });

        const token = '0200000066AEABE55060E60316BE65817C41A37B8BC1C49EA5407A25B83D6C604778FFD6CAFF7A2F04CD0277BC0BA31F0B50B85F';

        const config = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: data
        };

        const res = await enviarPeticion(config, REGISTRAR.SubirRUT);

        if (res.length > 0){
            //CUANDO FALLA DEVUELVE MENSAJE DE ERROR O VIENE VACÍO
            if (res !== "" && res !== "Error al leer" && res !== "Token no válido"){

                const tipoDoc = {TipoDocumento: undefined};
                const nuevoRes = JSON.parse(res);

                setFormulario({...nuevoRes, ...tipoDoc}); //AQUÍ GUARDAMOS EL CONTENIDO DEL RUT Y DEL FORMULARIO
                camposFaltgantes(JSON.parse(res)); //DEFINIMOS LOS CAMPOS QUE OBTUVIMOS Y LOS FALTANTES POR INGRESAR
                setAlert({ msg: 'RUT válido, completa la información faltante', severity: 'success', open: true });
                return JSON.parse(res);
            }
            else{
                setRut(null);
                setAlert({ msg: res === "" ? 'RUT No Válido' : res, severity: 'error', open: true });
                return "";
            }
        }
        else{
            setRut(null);
            setAlert({ msg: "Error del servidor, no se pudo leer RUT", severity: 'error', open: true });
            return "";
        }
    }

    //EVENTO CLIC FU RUT
    const handleRUTUpload = async (event) => {
        setLoading(true);

        //LA FUNCIÓN SOLO NOS REGRESARÁ LOS QUE SON VÁLIDOS
        const valido = validFiles(Array.from(event.target.files), "RUT");

        //SI ALGUNO NO FUE VÁLIDO LE DECIMOS AL USUARIO QUE NO TODOS SE SUBIRÁN
        if (valido.length < 1){
            setRut(null);
            setAlert({msg: 'Solo se permiten archivos menores a 5 mb en formato PDF', severity: 'warning', open: true });
        }
        else {
            const res = await subirRUT(valido); //LO SUBIMOS PARA OBTENER SU CONTENIDO

            if (res !== ""){

                //OBTENEMOS TOKEN PARA LAS PETICIONES
                const respuesta = await ObtenerToken();

                //VALIDAMOS SI OBTUVIMOS EL TOKEN
                if (respuesta.success === true){

                    const NITValido = await validarNIT(res.NIT, respuesta.data.token);

                    //SI NO HA SIDO DADO DE ALTA EN INTELISIS
                    if (NITValido === true){

                        //REVISAMOS QUE NO EXISTA UNA SOLICITUD PENDIENTE
                        const res2 = await validarSolicitudPendiente(res.NIT);

                        //FALSE ES QUE NO EXISTE SOLICITUD PENDIENTE
                        if (res2 === false){
                            setRut(valido); //GUARDAMOS EL DOCUMENTO COMO TAL
                        }
                        else{
                            setRut(null);
                            setAlert({msg: `Ya existe una solicitud en Revisión para el NIT ${res.NIT}`, severity: 'error', open: true });
                        }
                    }
                    else{
                        setRut(null);
                        setAlert({msg: `El RUT con NIT ${res.NIT} ya está registrado`, severity: 'error', open: true });
                    }
                }
                else{
                    setRut(null);
                    setAlert({msg: 'No se pudo validar el NIT', severity: 'error', open: true });
                }
            }
            else{
                setRut(null);
                setAlert({msg: 'No se pudo leer el contenido del RUT', severity: 'error', open: true });
            }
        }

        setLoading(false);
    }

    //SUBIR OTROS ARCHIVOS
    const subirArchivos = async (IdRegistro) => {
        const data = new FormData();
        data.append('IdRegistro', IdRegistro);

         //AGREGAMOS RUT
         rut.forEach((item) => {
            data.append('archivos', item);
        });

        //AGREGAMOS LOS DEMÁS ARCHIVOS
        docs.forEach((item) => {
            data.append('archivos', item);
        });

        const token = '0200000066AEABE55060E60316BE65817C41A37B8BC1C49EA5407A25B83D6C604778FFD6CAFF7A2F04CD0277BC0BA31F0B50B85F';

        const config = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: data
        };

        const res = await enviarPeticion(config, REGISTRAR.SubirDocs);
    }

    const handleFileDelete = (prop) => {
        //NOMBRE A BUSCAR
        const nombre = `${prop}.pdf`;

        //FILTRA EL DOCUMENTO CON ESE NOMBRE Y GUARDAMOS
        const newFiles = docs.filter(file => file.name !== nombre);
        setDocs(newFiles);

        //GUARDAMOS UN HOOK QUE MUESTRE LAS PALOMITAS
        const file = archivosElegidos(newFiles);
        setFiles(file);
    }

    //EVENTO CLIC OTROS ARCHIVOS
    const handleFileUpload = (event, prop) => {

        setLoading(true);

        //LA FUNCIÓN SOLO NOS REGRESARÁ LOS QUE SON VÁLIDOS Y CON EL NOMBRE QUE LE PASEMOS
        const valido = validFiles(Array.from(event.target.files), prop);

        //SI ALGUNO NO FUE VÁLIDO LE DECIMOS AL USUARIO QUE NO TODOS SE SUBIRÁN
        if (valido.length < 1) setAlert({msg: 'Solo se permiten archivos menores a 5 mb en formato PDF', severity: 'warning', open: true });
        else {
            //NOMBRE A BUSCAR
            const nombre = `${prop}.pdf`;

            //FILTRAMOS SI EXISTE
            const existe = docs.filter(file => file.name === nombre);

            //SI EXISTE LO QUITAMOS Y GUARDAMOS UN NUEVO ARRAY
            if (existe.length > 0){
                const newFiles = docs.filter(file => file.name !== nombre);
                newFiles.push(valido[0]);
                setDocs(newFiles);

                //GUARDAMOS UN HOOK QUE MUESTRE LAS PALOMITAS
                const file = archivosElegidos(newFiles);
                setFiles(file);
            }
            else{ //SOLO GUARDAMOS
                docs.push(valido[0]);
                setDocs(docs);

                //GUARDAMOS UN HOOK QUE MUESTRE LAS PALOMITAS
                const file = archivosElegidos(docs);
                setFiles(file);
            }

            //LIMPIAMOS INPUT
            event.target.files = null;
        }

        event.target.files = null;
        setLoading(false);
    }

    //GUARDA LA INFO DEL FORMULARIO
    const handleFormulario = (prop) => (event) => {

        setFormulario({...formulario, [prop]: event.target.value})
    }

    const validarCampos = () =>{

        const vacio = (toValid) => {
            const valor = toValid === undefined || toValid === null ? "" : toValid.toString();
            return valor === "" || valor.trim() === "" ? true : false;
        }

        //VERIFICAMOS CADA CAMPO DE FORMA PARTICULAR
        if(sqlCampo(formulario.Direccion) === true || vacio(formulario.Direccion) === true){
            setAlert({msg: 'Ingresa la Dirección', severity: "warning", open: true });
            return false;
        }

        if(sqlCampo(formulario.CodigoPostal) === true || (vacio(formulario.CodigoPostal) === true || /[0-9]/.test(formulario.CodigoPostal) === false)){
            setAlert({msg: 'Ingresa un Código Postal Válido', severity: "warning", open: true });
            return false;
        }

        if(sqlCampo(formulario.Telefono) === true || (vacio(formulario.Telefono) === true || /[0-9]/.test(formulario.Telefono) === false)){
            setAlert({msg: 'Ingresa el Teléfono de la Empresa', severity: "warning", open: true });
            return false;
        }

        if(sqlCampo(formulario.RepresentanteLegal) === true || vacio(formulario.RepresentanteLegal) === true){
            setAlert({msg: 'Ingresa el Representante Legal', severity: "warning", open: true });
            return false;
        }

        if(sqlCampo(formulario.TipoDocumento) === true || (vacio(formulario.TipoDocumento) === true || formulario.TipoDocumento === "Selecciona una opción") || formulario.TipoDocumento === "31" || formulario.TipoDocumento === "13"){
            setAlert({msg: 'Elige un tipo de documento de identificación', severity: "warning", open: true });
            return false;
        }

        if(sqlCampo(formulario.NumeroIdentificacion) === true || vacio(formulario.NumeroIdentificacion) === true || /[0-9]/.test(formulario.NumeroIdentificacion) === false){
            setAlert({msg: 'Ingresa el número de identificación', severity: "warning", open: true });
            return false;
        }

        if (vacio(formulario.ActividadEconomica1) === false && vacio(formulario.InicioActividad1) === false){
            if (sqlComentario(formulario.ActividadPrincipalDes) === true || vacio(formulario.ActividadPrincipalDes) === true){
                setAlert({msg: 'Describe la actividad principal', severity: "warning", open: true });
                return false;
            }
        }

        if (vacio(formulario.ActividadEconomica2) === false && vacio(formulario.InicioActividad2) === false){
            if (sqlComentario(formulario.ActividadSecundariaDes) === true || vacio(formulario.ActividadSecundariaDes) === true){
                setAlert({msg: 'Describe la actividad secundaria', severity: "warning", open: true });
                return false;
            }
        }

        if (sqlCampo(formulario.ActividadEconomicaMayorRiesgo) === true || (vacio(formulario.ActividadEconomicaMayorRiesgo) === true || /[0-9]/.test(formulario.ActividadEconomicaMayorRiesgo) === false)){
            setAlert({msg: 'Escribe la actividad de mayor riesgo', severity: "warning", open: true });
            return false;
        }

        if (sqlCampo(formulario.NombreSolicitante) === true || vacio(formulario.NombreSolicitante) === true){
            setAlert({msg: 'Escribe el nombre del contacto comercial', severity: "warning", open: true });
            return false;
        }

        if (sqlCampo(formulario.CargoDeSolicitante) === true || vacio(formulario.CargoDeSolicitante) === true){
            setAlert({msg: 'Escribe el cargo del contacto comercial', severity: "warning", open: true });
            return false;
        }

        if (sqlCampo(formulario.EmailSolicitante) === true || (vacio(formulario.EmailSolicitante) === true || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formulario.EmailSolicitante) === false)){
            setAlert({msg: 'Escribe un correo válido para el contacto comercial', severity: "warning", open: true });
            return false;
        }

        if (sqlCampo(formulario.TelefonoSolicitante) === true || (vacio(formulario.TelefonoSolicitante) === true || /[0-9]/.test(formulario.TelefonoSolicitante) === false)){
            setAlert({msg: 'Escribe el teléfono del contacto comercial', severity: "warning", open: true });
            return false;
        }

        if (sqlCampo(formulario.ContactoAdministrativoNombre) === true || vacio(formulario.ContactoAdministrativoNombre) === true){
            setAlert({msg: 'Escribe el nombre del contacto administrativo', severity: "warning", open: true });
            return false;
        }

        if (sqlCampo(formulario.ContactoAdministrativoEmail) === true || (vacio(formulario.ContactoAdministrativoEmail) === true || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formulario.ContactoAdministrativoEmail) === false)){
            setAlert({msg: 'Escribe un correo válido para el contacto administrativo', severity: "warning", open: true });
            return false;
        }

        if (sqlCampo(formulario.ContactoAdministrativoTelefono) === true || (vacio(formulario.ContactoAdministrativoTelefono) === true || /[0-9]/.test(formulario.ContactoAdministrativoTelefono) === false)){
            setAlert({msg: 'Escribe el teléfono del contacto administrativo', severity: "warning", open: true });
            return false;
        }

        if (sqlCampo(formulario.ComoNosConoce) === true || vacio(formulario.ComoNosConoce) === true){
            setAlert({msg: 'Elige la opción de cómo nos conociste', severity: "warning", open: true });
            return false;
        }

        if (sqlComentario(formulario.DondeConocioCompuSoluciones) === true || (formulario.ComoNosConoce === "Me contactaron" && vacio(formulario.DondeConocioCompuSoluciones) === true)){
            setAlert({msg: 'Escribe quién te contactó', severity: "warning", open: true });
            return false;
        }

        //DOCUMENTOS OBLIGATORIOS
        const ccc = docs.filter(file => file.name === "CamaraComercio.pdf");
        if (ccc.length < 1){
            setAlert({msg: 'Falta Certificado Cámara Comercio', severity: "warning", open: true });
            return false;
        }

        const irl = docs.filter(file => file.name === "RepresentanteLegal.pdf");
        if (irl.length < 1){
            setAlert({msg: 'Falta Identificación Representante Legal', severity: "warning", open: true });
            return false;
        }

        // const rc = docs.filter(file => file.name === "Referencia1.pdf");
        // if (rc.length < 1){
        //     setAlert({msg: 'Falta Carta Referencia Comercial 1', severity: "warning", open: true });
        //     return false;
        // }
        
        //HABEAS DATA
        if (check !== true){
            setAlert({msg: 'Debes aceptar los términos y condiciones', severity: "warning", open: true });
            return false;
        }

        //SI PASA LAS VALIDACIONES CERRRAMOS EL ALERT
        setAlert({ msg: '', severity: 'success', open: false });

        //SI LLEGA HASTA AQUÍ REGRESAMOS TRUE
        return true;
    }

    const realizarRegistro = async() => {
        setLoading(true);

        //VALIDACIONES
        const validaciones = validarCampos();

        if (validaciones === true){
            //AGREGAMOS CADA UNO DE LOS PARÁMETROS
            const conoce = formulario.ComoNosConoce === "Me contactaron" ? `Me contactó ${formulario.DondeConocioCompuSoluciones}` : formulario.ComoNosConoce;

            const data = {
                RazonSocial: formulario.RazonSocial,
                NIT: formulario.NIT,
                DV: formulario.DV,
                Direccion: formulario.Direccion,
                Telefono: formulario.Telefono,
                CodigoPostal: formulario.CodigoPostal,
                Municipio: formulario.Municipio,
                Departamento: formulario.Departamento,
                RepresentanteLegal: formulario.RepresentanteLegal,
                TipoDocumento: formulario.TipoDocumento,
                NumeroIdentificacion: formulario.NumeroIdentificacion,
                Correo: formulario.EmailSolicitante,
                ActividadEconomica1: formulario.ActividadEconomica1,
                ActividadPrincipalDes: formulario.ActividadPrincipalDes,
                InicioActividad1: formulario.InicioActividad1,
                ActividadEconomica2: formulario.ActividadEconomica2 === "" || formulario.ActividadEconomica2 === undefined || formulario.ActividadEconomica2 === null  ? '' : formulario.ActividadEconomica2,
                ActividadSecundariaDes: formulario.ActividadSecundariaDes === "" || formulario.ActividadSecundariaDes === undefined || formulario.ActividadSecundariaDes === null  ? '' : formulario.ActividadSecundariaDes,
                InicioActividad2: formulario.InicioActividad2 === "" || formulario.InicioActividad2 === undefined || formulario.InicioActividad2 === null  ? '' : formulario.InicioActividad2,
                ActividadEconomicaMayorRiesgo: formulario.ActividadEconomicaMayorRiesgo,
                OtrasActividades: otrasAct === "" || otrasAct === undefined || otrasAct === null  ? '' : otrasAct,
                Regimen: formulario.Regimen,
                TipoContribuyente: formulario.TipoContribuyente,
                ContactoAdministrativoNombre: formulario.ContactoAdministrativoNombre,
                ContactoAdministrativoEmail: formulario.ContactoAdministrativoEmail,
                ContactoAdministrativoTelefono: formulario.ContactoAdministrativoTelefono,
                NombreSolicitante: formulario.NombreSolicitante,
                TelefonoSolicitante: formulario.TelefonoSolicitante,
                EmailSolicitante: formulario.EmailSolicitante,
                CargoDeSolicitante: formulario.CargoDeSolicitante,
                ComoNosConoce: conoce,
                Codigos: formulario.CodigosResponsabilidades
            };

            const token = '0200000066AEABE55060E60316BE65817C41A37B8BC1C49EA5407A25B83D6C604778FFD6CAFF7A2F04CD0277BC0BA31F0B50B85F';

            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(data)
            };

            const res = await enviarPeticion(config, REGISTRAR.RegistrarCliente);

            //SI ES DIFERENTE A UN ERROR SUBIMOS LOS ARCHIVOS
            if (res.WasSuccessful === true){

                //SUBIR DOCUMENTOS
                await subirArchivos(res.data);

                //MOSTRAMOS MODAL DE CONFIRMACIÓN
                setShowModal(true);
            }
            else{
                setAlert({msg: 'Error al registrar la solicitud', severity: "error", open: true });
            }
        }

        setLoading(false);
    }

     return (<>
     <Helmet>
        <title>Bienvenido/a</title>
     </Helmet>

     {
        loading ?
        <div className={'container'}>
            <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress size={100} thickness={2}></CircularProgress>
            </div>
        </div>
        :
        <div className={'container'}>
            <div className="fontNewsGothic">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    {
                        alert.open ? <Alert msg={alert.msg} open={alert.open} severity={alert.severity} segundos={5} closeAlert={closeAlert}/> : <></>
                    }

                    {/* INICIO MODAL REGISTRO */}
                    <ModalCS show={showModal} size='md' title='GRACIAS' body={
                        <div>
                            <div className="col-sm-12 col-md-12 col-lg-12">     
                                <div className="col-sm-12 col-md-12 col-lg-12" style={{textAlign: '-webkit-center'}}>                        
                                    <LabelCS label='Haz concluido el primer paso en tu alta como cliente.'></LabelCS>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12">     
                                <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">                        
                                    <LabelCS label='Nos pondremos en contacto a la brevedad para terminar el proceso.'></LabelCS>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">     
                                <div className="col-sm-12 col-md-12 col-lg-12" style={{textAlign: '-webkit-center'}}>                             
                                    <BotonCS title="Aceptar" handleSubmit={cerrarModal}></BotonCS>
                                </div>
                            </div>

                        </div>
                    }></ModalCS>
                    {/* FIN MODAL REGISTRO*/}

                    <br />
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-12 col-md-12 col-lg-12" style={{textAlign: 'center'}}>
                            <label className='tituloSeccionCentrado'>GRACIAS POR TU INTERÉS</label>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-12 col-md-12 col-lg-12" style={{textAlign: 'center'}}>
                            <LabelCS variant='subtitle1' label='Te invitamos a formar parte de nuestra cadena de distribuidores' />   
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-12 col-md-12 col-lg-12" style={{textAlign: 'center'}}>
                            <LabelCS variant='subtitle1' label='Ayúdanos a completar la siguiente información' /> 
                        </div>
                    </div>
                    <br />
                    <br />

                    {/* INICIO RUT */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Registro Único Tributario</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-4 col-md-4 col-lg-4"></div>
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='PDF menor a 5 mb' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <input type="file" accept=".pdf" id='fluRUT' onChange={handleRUTUpload} multiple={false}></input>
                        </div>
                        <div className="col-sm-4 col-md-4 col-lg-4"></div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    {/* FIN RUT */}

                    {/* SI EL RUT ES VÁLIDO MOSTRAMOS LO SIGUIENTE */}
                    {
                        rut !== null ? 
                        <>
                        {/* INICIO CONTENIDO RUT */}
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <label className='tituloSeccion'>Información General de la Empresa</label>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Razón Social' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <TextFieldCS name="" disabled={true} value={formulario.RazonSocial}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='NIT' />   
                            </div>    
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <TextFieldCS name="" disabled={true} value={formulario.NIT}></TextFieldCS>
                            </div>   
                            <div className="col-sm-1 col-md-1 col-lg-1">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='DV' />   
                            </div>    
                            <div className="col-sm-1 col-md-1 col-lg-1">
                                <TextFieldCS name="" disabled={true} value={formulario.DV}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Dirección' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                                {
                                    formulario.Direccion === null || formulario.Direccion === undefined || formulario.Direccion === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" disabled={disabled.Direccion ?? false} onChange={handleFormulario('Direccion')} value={formulario.Direccion}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Código Postal' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                                {
                                    formulario.CodigoPostal === null || formulario.CodigoPostal === undefined || formulario.CodigoPostal === "" || formulario.CodigoPostal.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS  name="" type="number" disabled={disabled.CodigoPostal ?? false} onChange={handleFormulario('CodigoPostal')} value={formulario.CodigoPostal}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Teléfono' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                                {
                                    formulario.Telefono === null || formulario.Telefono === undefined || formulario.Telefono === "" || formulario.Telefono.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" disabled={disabled.Telefono ?? false} onChange={handleFormulario('Telefono')} value={formulario.Telefono}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Municipio' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <TextFieldCS name="" disabled={disabled.Municipio ?? false} value={formulario.Municipio}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Departamento' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <TextFieldCS name="" disabled={disabled.Departamento ?? false} value={formulario.Departamento}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Representante Legal' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                                {
                                    formulario.RepresentanteLegal === null || formulario.RepresentanteLegal === undefined || formulario.RepresentanteLegal === "" || formulario.RepresentanteLegal.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" disabled={disabled.RepresentanteLegal ?? false} onChange={handleFormulario('RepresentanteLegal')} value={formulario.RepresentanteLegal}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Tipo Documento Identificación' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display:'flex'}}>
                                {
                                    formulario.TipoDocumento === null || formulario.TipoDocumento === undefined || formulario.TipoDocumento === "" || formulario.TipoDocumento.trim() === "" ?
                                    <label style={{color: 'red', width: '12px'}}>*</label>
                                    : <></>
                                }
                                <DropDownListCS items={[{value: 'Selecciona una opción'}, {value: 'Cédula de Ciudadanía'}, {value: 'Cédula de Extranjería'}, {value: 'Pasaporte'}]} default={formulario.TipoDocumento} onChange={handleFormulario('TipoDocumento')}></DropDownListCS>
                                {/* <TextFieldCS name="" disabled={disabled.TipoDocumento ?? false} value={formulario.TipoDocumento==="31"?"NIT":formulario.TipoDocumento}></TextFieldCS> */}
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Número Identificación' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                                {
                                    formulario.NumeroIdentificacion === null || formulario.NumeroIdentificacion === undefined || formulario.NumeroIdentificacion === "" || formulario.NumeroIdentificacion.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" type="number" disabled={disabled.NumeroIdentificacion ?? false} value={formulario.NumeroIdentificacion} onChange={handleFormulario('NumeroIdentificacion')}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Actividad Primaria' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <TextFieldCS name="" disabled={true} value={formulario.ActividadEconomica1}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Inicio Actividad Primaria' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <TextFieldCS name="" disabled={true} value={formatDate(formulario.InicioActividad1)}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '80px'}}>
                            <div className="col-sm-2 col-md-2 col-lg-2" style={{display: 'flex', height: '80px', alignItems: 'center'}}>
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Descripción Actividad Primaria' />   
                            </div>    
                            <div className="col-sm-10 col-md-10 col-lg-10" style={{display: 'flex'}}>
                                {
                                    formulario.ActividadPrincipalDes === null || formulario.ActividadPrincipalDes === undefined || formulario.ActividadPrincipalDes === "" || formulario.ActividadPrincipalDes.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" onChange={handleFormulario('ActividadPrincipalDes')} value={formulario.ActividadPrincipalDes} multiline maxRows={3}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Actividad Secundaria' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <TextFieldCS name="" disabled={true} value={formulario.ActividadEconomica2}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Inicio Actividad Secundaria' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <TextFieldCS name="" disabled={true} value={formatDate(formulario.InicioActividad2)}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '80px'}}>
                            <div className="col-sm-2 col-md-2 col-lg-2" style={{display: 'flex', height: '80px', alignItems: 'center'}}>
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Descripción Actividad Secundaria' />   
                            </div>    
                            <div className="col-sm-10 col-md-10 col-lg-10" style={{display: 'flex'}}>
                                {
                                    (formulario.ActividadEconomica2 !== "" && formulario.InicioActividad2 !== "") &&
                                    (formulario.ActividadSecundariaDes === null || formulario.ActividadSecundariaDes === undefined || formulario.ActividadSecundariaDes === "" || formulario.ActividadSecundariaDes.trim() === "") ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" disabled={formulario.ActividadEconomica2 === "" && formulario.InicioActividad2 === "" ? true : false} onChange={handleFormulario('ActividadSecundariaDes')} value={formulario.ActividadSecundariaDes} multiline maxRows={3}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Código Actividad Mayor Riesgo' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                                {
                                    formulario.ActividadEconomicaMayorRiesgo === null || formulario.ActividadEconomicaMayorRiesgo === undefined || formulario.ActividadEconomicaMayorRiesgo === "" || formulario.ActividadEconomicaMayorRiesgo.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS type="number" name="" onChange={handleFormulario('ActividadEconomicaMayorRiesgo')} value={formulario.ActividadEconomicaMayorRiesgo}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Otras Actividades' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <TextFieldCS name="" disabled={true} value={otrasAct}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Tipo Régimen' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <TextFieldCS name="" disabled={true} value={formulario.Regimen}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Tipo Contribuyente' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <TextFieldCS name="" disabled={true} value={formulario.TipoContribuyente}></TextFieldCS>
                            </div>   
                        </div>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        {/* FIN CONTENIDO RUT */}
                        
                        {/* INICIO DATOS DEL CONTACTO COMERCIAL */}
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <label className='tituloSeccion'>Contacto Comercial</label>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Nombre' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display:'flex'}}>
                                {
                                    formulario.NombreSolicitante === null || formulario.NombreSolicitante === undefined || formulario.NombreSolicitante === "" || formulario.NombreSolicitante.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" onChange={handleFormulario('NombreSolicitante')} value={formulario.NombreSolicitante ?? ''}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Cargo' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                                {
                                    formulario.CargoDeSolicitante === null || formulario.CargoDeSolicitante === undefined || formulario.CargoDeSolicitante === "" || formulario.CargoDeSolicitante.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" onChange={handleFormulario('CargoDeSolicitante')} value={formulario.CargoDeSolicitante ?? ''}></TextFieldCS>
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Email' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display:'flex'}}>
                                {
                                    formulario.EmailSolicitante === null || formulario.EmailSolicitante === undefined || formulario.EmailSolicitante === "" || formulario.EmailSolicitante.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" onChange={handleFormulario('EmailSolicitante')} value={formulario.EmailSolicitante ?? ''}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Teléfono' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display:'flex'}}>
                                {
                                    formulario.TelefonoSolicitante === null || formulario.TelefonoSolicitante === undefined || formulario.TelefonoSolicitante === "" || formulario.TelefonoSolicitante.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS type="number" name="" onChange={handleFormulario('TelefonoSolicitante')} value={formulario.TelefonoSolicitante ?? ''}></TextFieldCS>
                            </div>   
                        </div>
                        <br/>
                        <br/>
                        {/* FIN DATOS DEL CONTACTO COMERCIAL */}

                        {/* INICIO DATOS DEL CONTACTO ADMINISTRATIVO */}
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <label className='tituloSeccion'>Contacto Administrativo</label>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Nombre' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display:'flex'}}>
                                {
                                    formulario.ContactoAdministrativoNombre === null || formulario.ContactoAdministrativoNombre === undefined || formulario.ContactoAdministrativoNombre === "" || formulario.ContactoAdministrativoNombre.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" onChange={handleFormulario('ContactoAdministrativoNombre')} value={formulario.ContactoAdministrativoNombre ?? ''}></TextFieldCS>
                            </div>   
                            <div className="col-sm-6 col-md-6 col-lg-6">
                            </div>   
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Email' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display:'flex'}}>
                                {
                                    formulario.ContactoAdministrativoEmail === null || formulario.ContactoAdministrativoEmail === undefined || formulario.ContactoAdministrativoEmail === "" || formulario.ContactoAdministrativoEmail.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS name="" onChange={handleFormulario('ContactoAdministrativoEmail')} value={formulario.ContactoAdministrativoEmail ?? ''}></TextFieldCS>
                            </div>   
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Teléfono' />   
                            </div>    
                            <div className="col-sm-4 col-md-4 col-lg-4" style={{display:'flex'}}>
                                {
                                    formulario.ContactoAdministrativoTelefono === null || formulario.ContactoAdministrativoTelefono === undefined || formulario.ContactoAdministrativoTelefono === "" || formulario.ContactoAdministrativoTelefono.trim() === "" ?
                                    <label style={{color: 'red'}}>*</label>
                                    : <></>
                                }
                                <TextFieldCS type="number" name="" onChange={handleFormulario('ContactoAdministrativoTelefono')} value={formulario.ContactoAdministrativoTelefono ?? ''}></TextFieldCS>
                            </div>   
                        </div>
                        <br/>
                        <br/>
                        {/* FIN DATOS DEL CONTACTO ADMINISTRATIVO */}

                        {/* INICIO CÓMO SE ENTERA */}
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <label className='tituloSeccion'>Cómo Nos Conoce</label>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-2 col-md-2 col-lg-2">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='¿Dónde se enteró de CompuSoluciones?' />   
                            </div>    
                            <div className="col-sm-10 col-md-10 col-lg-10">
                                <div className='col-sm-12 col-md-12 col-lg-12 contenedorCentrado' style={{textAlign: 'left'}}>
                                    {
                                        formulario.ComoNosConoce === null || formulario.ComoNosConoce === undefined || formulario.ComoNosConoce === "" || formulario.ComoNosConoce.trim() === "" ?
                                        <label style={{color: 'red'}}>*</label>
                                        : <></>
                                    }
                                    <div className='col-sm-2 col-md-2 col-lg-2'>
                                        <label>
                                            <input type='radio' value='Redes sociales' checked={formulario.ComoNosConoce === 'Redes sociales' ? true : false} onChange={handleFormulario('ComoNosConoce')} />
                                            Redes sociales
                                        </label>
                                    </div>
                                    <div className='col-sm-2 col-md-2 col-lg-2'>
                                        <label>
                                            <input type='radio' value='Página web' checked={formulario.ComoNosConoce === 'Página web' ? true : false} onChange={handleFormulario('ComoNosConoce')} />
                                            Página web
                                        </label>
                                    </div>
                                    <div className='col-sm-2 col-md-2 col-lg-2'>
                                        <label>
                                            <input type='radio' value='Evento' checked={formulario.ComoNosConoce === 'Evento' ? true : false} onChange={handleFormulario('ComoNosConoce')} />
                                            Evento
                                        </label>
                                    </div>
                                    <div className='col-sm-2 col-md-2 col-lg-2'>
                                        <label>
                                            <input type='radio' value='Me contactaron' checked={formulario.ComoNosConoce === 'Me contactaron' ? true : false} onChange={handleFormulario('ComoNosConoce')} />
                                            Me contactaron
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-md-4 col-lg-4'>
                                        <label>
                                            <input type='radio' value='Recomendación de tercero' checked={formulario.ComoNosConoce === 'Recomendación de tercero' ? true : false} onChange={handleFormulario('ComoNosConoce')} />
                                            Recomendación de tercero
                                        </label>
                                    </div>
                                </div>
                            </div>   
                        </div>
                        {
                            formulario.ComoNosConoce === "Me contactaron" ? 
                            <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                                <div className="col-sm-2 col-md-2 col-lg-2">
                                    <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='¿Quién lo contactó?' />   
                                </div>    
                                <div className="col-sm-10 col-md-10 col-lg-10">
                                    <div className='col-sm-12 col-md-12 col-lg-12 contenedorCentrado' style={{textAlign: 'left'}}>
                                        {
                                            formulario.DondeConocioCompuSoluciones === null || formulario.DondeConocioCompuSoluciones === undefined || formulario.DondeConocioCompuSoluciones === "" || formulario.DondeConocioCompuSoluciones.trim() === "" ?
                                            <label style={{color: 'red'}}>*</label>
                                            : <></>
                                        }
                                        <TextFieldCS name="" onChange={handleFormulario('DondeConocioCompuSoluciones')} value={formulario.DondeConocioCompuSoluciones ?? ''}></TextFieldCS>
                                    </div>
                                </div>
                            </div>
                            : <></>
                        }
                        <br/>
                        <br/>
                        {/* FIN CÓMO SE ENTERA */}

                        {/* INICIO TODOS DOCUMENTOS */}
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <label className='tituloSeccion'>Documentos</label>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '50px'}}>
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Registro Único Tributario' />   
                            </div>    
                            <div className="col-sm-8 col-md-8 col-lg-8" style={{verticalAlign: 'unset'}}>
                                <img src="True.png"></img>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '50px'}}>
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Certificado Cámara Comercio' />   
                            </div>   
                            <div className="col-sm-1 col-md-1 col-lg-1">
                            {files.ccc !== null && files.ccc !== undefined ? 
                                <>
                                    <img src="True.png"></img>
                                </> : <></>}
                            </div> 
                            <div className="col-sm-1 col-md-1 col-lg-1">
                                {files.ccc !== null && files.ccc !== undefined ? 
                                <><Tooltip title='Eliminar' placement='top'>
                                    <Delete className="hoverOptions" onClick={ () => {handleFileDelete('CamaraComercio') }}></Delete>
                                </Tooltip>
                                </> : <></>}
                            </div> 
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <input type="file" accept=".pdf" onChange={(event) => handleFileUpload(event, 'CamaraComercio')} multiple={false}></input>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '50px'}}>
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Identificación Representante Legal' />   
                            </div>    
                            <div className="col-sm-1 col-md-1 col-lg-1">
                            {files.irl !== null && files.irl !== undefined ? 
                                <>
                                    <img src="True.png"></img>
                                </> : <></>}
                            </div> 
                            <div className="col-sm-1 col-md-1 col-lg-1">
                                {files.irl !== null && files.irl !== undefined ? 
                                <><Tooltip title='Eliminar' placement='top'>
                                    <Delete className="hoverOptions" onClick={ () => {handleFileDelete('RepresentanteLegal') }}></Delete>
                                </Tooltip>
                                </> : <></>}
                            </div> 
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <input type="file" accept=".pdf" onChange={(event) => handleFileUpload(event, 'RepresentanteLegal')} multiple={false}></input>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '50px'}}>
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Carta Referencia Comercial 1' />   
                            </div>    
                            <div className="col-sm-1 col-md-1 col-lg-1">
                            {files.cr1 !== null && files.cr1 !== undefined ? 
                                <>
                                    <img src="True.png"></img>
                                </> : <></>}
                            </div> 
                            <div className="col-sm-1 col-md-1 col-lg-1">
                                {files.cr1 !== null && files.cr1 !== undefined ? 
                                <><Tooltip title='Eliminar' placement='top'>
                                    <Delete className="hoverOptions" onClick={ () => {handleFileDelete('Referencia1') }}></Delete>
                                </Tooltip>
                                </> : <></>}
                            </div> 
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <input type="file" accept=".pdf" onChange={(event) => handleFileUpload(event, 'Referencia1')} multiple={false}></input>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '50px'}}>
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Carta Referencia Comercial 2' />   
                            </div>    
                            <div className="col-sm-1 col-md-1 col-lg-1">
                            {files.cr2 !== null && files.cr2 !== undefined ? 
                                <>
                                    <img src="True.png"></img>
                                </> : <></>}
                            </div> 
                            <div className="col-sm-1 col-md-1 col-lg-1">
                                {files.cr2 !== null && files.cr2 !== undefined ? 
                                <><Tooltip title='Eliminar' placement='top'>
                                    <Delete className="hoverOptions" onClick={ () => {handleFileDelete('Referencia2') }}></Delete>
                                </Tooltip>
                                </> : <></>}
                            </div> 
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <input type="file" accept=".pdf" onChange={(event) => handleFileUpload(event, 'Referencia2')} multiple={false}></input>
                            </div>
                        </div>
                        <br/>
                        <br/>
                        <br/>
                        {/* FIN TODOS DOCUMENTOS */}

                        {/* INICIO HABEAS DATA */}
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '100%'}}>
                            <LabelCS variant='subtitle1' style={{ textAlign: 'center'}} label='Al momento de diligenciar el formulario autoriza a CompuSoluciones y Asociados S.A.S. NIT. 901.476.610-4 y página web www.compusoluciones.com.co como responsable del tratamiento de sus datos para registrarse como distribuidor, enviar confirmación del registro y recordatorios e información de la relación comercial. Podrá consultar la Política de Protección de Datos Personales de CompuSoluciones y Asociados S.A.S. en www.compusoluciones.com.co/aviso-de-privacidad y ejercer sus derechos a acceder, conocer, modificar, actualizar, rectificar, suprimir o revocar la información escribiendo al correo legal@compusoluciones.com.' />  
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '100%'}}>
                            <div className="col-sm-5 col-md-5 col-lg-5">
                            </div>
                            <div className="col-sm-2 col-md-2 col-lg-2" style={{height: '100%', textAlign: '-webkit-center', display: 'block'}}>
                                <label>
                                    <input type='checkbox' checked={check} onChange={checkHabeasData} />
                                    Estoy de acuerdo
                                </label>
                                <br/>
                                <br/>
                                <BotonCS title='Realizar Registro' handleSubmit={realizarRegistro}></BotonCS>
                            </div>
                            <div className="col-sm-5 col-md-5 col-lg-5">
                            </div>
                        </div>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        {/* FIN HABEAS DATA */}
                        </>
                        : <></>
                    }


                </div>
            </div>
        </div>

     }
     </>)
}

export default React.memo(FormularioAlta);